import Vue from 'vue'
import {
  AutoComplete,
  Button,
  Checkbox,
  Col,
  DatePicker,
  Empty,
  Icon,
  Input,
  InputNumber,
  Layout,
  Menu,
  message,
  Modal,
  Popconfirm,
  Row,
  Select,
  Spin,
  Table,
  Tag,
  Timeline,
  TreeSelect,
  Radio,
  Tooltip,
  Carousel,
  List
} from 'ant-design-vue'
import App from './App.vue'
import router from './router'
import { get, post } from './common/request'
import Print from 'vue-print-nb'

import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';

import VueGoogleApi from 'vue-google-api'
const config = {
  apiKey: 'AIzaSyCgjAD9hoWNeuxmrybgnBD4A1z2lArW7UM',
  clientId: '970117889595-r62o3sf8st0vg14a5e36ivqgbkem4dpg.apps.googleusercontent.com',
  scope: 'https://www.googleapis.com/auth/calendar',
  discoveryDocs: [ "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest" ]
}


Vue.use(Button)
Vue.use(message)
Vue.use(Modal)
Vue.use(Input)
Vue.use(Icon)
Vue.use(Row)
Vue.use(Col)
Vue.use(DatePicker)
Vue.use(Select)
Vue.use(Spin)
Vue.use(Empty)
Vue.use(TreeSelect)
Vue.use(InputNumber)
Vue.use(Layout)
Vue.use(AutoComplete)
Vue.use(Timeline)
Vue.use(Menu)
Vue.use(Tag)
Vue.use(Table)
Vue.use(Popconfirm)
Vue.use(Checkbox)
Vue.use(Radio)
Vue.use(Tooltip)
Vue.use(Carousel)
Vue.use(List)
Vue.use(Print)
Vue.use(VueGoogleApi, config)
// Vue.use(Blob)
// Vue.use(Export2Excel)
Vue.component('quill-editor', quillEditor);
Vue.prototype.$post = post
Vue.prototype.$get = get

Vue.config.productionTip = false
Vue.prototype.$message = message
Vue.prototype.$confirm = Modal.confirm

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
